import styled from '@emotion/styled';
import RelationshipManagerContacts from '../components/RelationshipManagerContacts';
import {
    ChatContentConstants,
    CONTACT_RM__HEADER,
    CONTACT_RM_DEFAULT_HEADER,
    CONTACT_RM_DEFAULT_SUBHEADER,
} from '../constants';
import { useChatBlkStore } from '../hooks';

const ContactPageHeader = styled.h1`
    color: #000;
    font-feature-settings:
        'liga' off,
        'clig' off;

    /* Responsive/Heading L */
    font-family: var(--Typography-Family-Heading, 'BLK Fort');
    font-size: var(--Typography-Size-Heading-L, 26px);
    font-style: normal;
    font-weight: 800;
    line-height: var(--Typography-Line-height-Heading-L, 32px); /* 123.077% */
    letter-spacing: var(--Typography-Letter-spacing-Heading-L, 0px);
`;

const ContactPageSubheader = styled.h2`
    color: #000;

    font-feature-settings:
        'liga' off,
        'clig' off;
    /* Responsive/Body M */
    font-family: var(--Typography-Family-blk-body, 'BLK Fort');
    font-size: var(--Typography-Size-blk-body-m, 16px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Typography-Line-height-blk-body-m, 24px); /* 150% */
    letter-spacing: var(--Typography-Letter-spacing-blk-body-m, 0px);
`;

const ContactPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem;
    height: 100%;
    overflow-y: auto;
    margin-top: 2.5rem;
    padding-right: 4rem;
    align-items: center;
`;

const ContactsWrapper = styled.div`
    max-width: 1920px;
    display: flex;
    gap: 1rem;
    text-align: left;
    flex-grow: 1;
    width: 100%;
    flex-direction: column;
`;
const { CONTACT_RM_SLOT } = ChatContentConstants;

/**
 * RmContactPage component renders the RM contact page.
 *
 * @returns {JSX.Element} The rendered RM contact page component.
 * @component
 */
const RmContactPage = (): JSX.Element => {
    const { activeContent, relationshipManagers = [] } = useChatBlkStore();
    const hasContacts =
        relationshipManagers?.length &&
        relationshipManagers[0]?.role !== 'DEFAULT';

    return activeContent === CONTACT_RM_SLOT ? (
        <ContactPageContainer
            hidden={activeContent !== CONTACT_RM_SLOT}
            slot={CONTACT_RM_SLOT}
        >
            <ContactsWrapper>
                <ContactPageHeader>
                    {relationshipManagers?.length && hasContacts
                        ? CONTACT_RM__HEADER
                        : CONTACT_RM_DEFAULT_HEADER}
                </ContactPageHeader>
                <ContactPageSubheader>
                    {hasContacts ? '' : CONTACT_RM_DEFAULT_SUBHEADER}
                </ContactPageSubheader>
                <RelationshipManagerContacts />
            </ContactsWrapper>
        </ContactPageContainer>
    ) : null;
};

export default RmContactPage;
